module.exports = __webpack_public_path__ + "img/myProducts.38017a53.svg";